import {eventsActionTypes} from '../../constants';

const initialState = {
    events: [],
    upcomingEvents: [],
    featuredEvents: [],
    eventDetails: null,
    isLoading: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case eventsActionTypes.FETCH_EVENTS:
            return {
                ...state,
                events: action.payload,
                isLoading: false,
            };
        case eventsActionTypes.FETCH_UPCOMING_EVENTS:
            return {
                ...state,
                upcomingEvents: action.payload,
                isLoading: false,
            };
        case eventsActionTypes.FETCH_FEATURED_EVENTS:
            return {
                ...state,
                featuredEvents: action.payload,
                isLoading: false,
            };
        case eventsActionTypes.SET_EVENT_DETAILS:
            return {
                ...state,
                eventDetails: action.payload,
                isLoading: false,
            };
        case eventsActionTypes.CLEAR_EVENT_DETAILS:
            return {
                ...state,
                eventDetails: null,
                isLoading: false,
            };
        default:
            return state;
    }
};
